export const LOCALSTORAGE_AUTH_TOKEN = 'LOCALSTORAGE_AUTH_TOKEN';
export const LOCALSTORAGE_AUTH_USER = 'LOCALSTORAGE_AUTH_USER';